var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4912 10.2344C19.4912 4.88281 15.1553 0.546875 9.80371 0.546875C4.45215 0.546875 0.116211 4.88281 0.116211 10.2344C0.116211 15.0781 3.63184 19.1016 8.28027 19.8047V13.0469H5.81934V10.2344H8.28027V8.125C8.28027 5.70312 9.72559 4.33594 11.9131 4.33594C13.0068 4.33594 14.1006 4.53125 14.1006 4.53125V6.91406H12.8896C11.6787 6.91406 11.2881 7.65625 11.2881 8.4375V10.2344H13.9834L13.5537 13.0469H11.2881V19.8047C15.9365 19.1016 19.4912 15.0781 19.4912 10.2344Z",
    fill: "#FBF8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.f5bb257b6f4e7eab01b2a24efb2bd0f3.svg";
export { ForwardRef as ReactComponent };